module.exports = __webpack_public_path__ + "img/分区06.8c78abff.png";